import { useMatches, Link, UIMatch } from "react-router";
import { useAppSelector } from "../../services/hooks";
import { Breadcrumb } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function Breadcrumbs() {
    const { t } = useTranslation('')
    const matches = useMatches();

    const productName = useAppSelector((state) => state.product.data?.name)
    const productCategory = useAppSelector((state) => {
        if (state.product.data.categories) {
            if (state.product.data.categories[0].name)
                return state.product.data.categories[0].name
        }
    })

    const crumbs = matches
        .filter((match): match is UIMatch<object, { breadcrumb: string | ((match: UIMatch) => string) }> =>
            Boolean((match.handle as any)?.breadcrumb)
        )
        .map((match) => {
            const breadcrumb = match.handle.breadcrumb;
            const path =
                typeof breadcrumb === "function" && breadcrumb(match) === "mainCategory"
                    ? null
                    : match.pathname
            const label =
                typeof breadcrumb === "function"
                    ? breadcrumb(match) === "mainCategory"
                        ? productCategory ? `${t('title.mainCategory')} ${productCategory}` : ''
                        : breadcrumb(match) === "singleProduct"
                            ? `${t('title.singleProduct')} ${productName}`
                            : breadcrumb(match)
                    : breadcrumb;
            const isTranslated =
                typeof breadcrumb === "function" && breadcrumb(match) === "singleProduct"
                    ? true
                    : false;
            return {
                label,
                path,
                isTranslated: isTranslated
            };
        });

    return (<>
        {crumbs.length > 0 &&
            <div className="bg-light bg-gradient border-top border-1 px-3 border-light-subtle">
                <nav>
                    <Breadcrumb className="m-0 p-2" listProps={{ className: "m-0" }}>
                        {crumbs.map((crumb, i) => {
                            if (i + 1 < crumbs.length) {
                                return (<>
                                    {crumb.path && crumb.label &&
                                        <Breadcrumb.Item key={i}>
                                            <Link to={crumb.path}>
                                                <small style={{ textDecoration: 'underline' }}>
                                                    {crumb.isTranslated
                                                        ? crumb.label
                                                        : t(`title.${crumb.label}`)
                                                    }
                                                </small>
                                            </Link>
                                        </Breadcrumb.Item>
                                    }
                                </>
                                )
                            } else {
                                return (<>
                                    {crumb.label &&
                                        <Breadcrumb.Item active key={i}>
                                            <small>
                                                {crumb.isTranslated
                                                    ? crumb.label
                                                    : t(`title.${crumb.label}`)
                                                }
                                            </small>
                                        </Breadcrumb.Item>
                                    }
                                </>
                                )
                            }
                        })}
                    </Breadcrumb>
                </nav>
            </div>
        }
    </>
    );
}


{/* <nav style="--bs-breadcrumb-divider: '/';" aria-label="breadcrumb">
    <ol class="breadcrumb m-0 p-2" id="breadCrumb">
        <li class="breadcrumb-item">
            <a href="https://trial.romer.com.pl/lang-pl/categories/159-aplikatory" class="link-dark">
                <small>Aplikatory</small>
            </a>                        </li>
        <li class="breadcrumb-item">
            <small>Aplikator ProfiSpray Base (EU)</small>
        </li>
    </ol>
</nav> */}